// Transforms a pair of mount/unmount functions to use a reference counter.
// Useful for managing React components that depend on global state.
//
// For more about the reference counter pattern, see:
//   https://en.wikipedia.org/wiki/Reference_counting
const withReferenceCounter = ({
  mount,
  unmount
}) => {
  let referenceCount = 0;
  return {
    mount: () => {
      referenceCount = Math.max(referenceCount + 1, 0);

      if (referenceCount === 1) {
        mount();
      }
    },
    unmount: () => {
      if (referenceCount === 1) {
        unmount();
      }

      referenceCount = Math.max(referenceCount - 1, 0);
    }
  };
};

export default withReferenceCounter;